import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type {
  ViewItemEvent,
  ViewProductDetailEvent,
} from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const VIEW_PRODUCT_DETAIL_EVENT = 'view_product_detail'
const VIEW_ITEM_EVENT = 'view_item'

export const triggerViewProductDetailEvent = (event: ViewProductDetailEvent) =>
  triggerEvent(VIEW_PRODUCT_DETAIL_EVENT, event)

export const triggerViewItemEvent = (event: ViewItemEvent) =>
  triggerEvent(VIEW_ITEM_EVENT, event)

export const onViewProductDetailEvent = (
  callback: EventCallback<ViewProductDetailEvent>
) => subscribeEvent(VIEW_PRODUCT_DETAIL_EVENT, callback)

export const onViewItemEvent = (callback: EventCallback<ViewItemEvent>) =>
  subscribeEvent(VIEW_ITEM_EVENT, callback)

export const removeViewProductDetailEvent = (
  token: EventToken<ViewProductDetailEvent>
) => unsubscribeEvent(VIEW_PRODUCT_DETAIL_EVENT, token)

export const removeViewItemEvent = (token: EventToken<ViewItemEvent>) =>
  unsubscribeEvent(VIEW_ITEM_EVENT, token)
